import { DatePipe } from '@angular/common';
import { Component, ElementRef, Input, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { IonDatetime, ModalController } from '@ionic/angular';
import {
  endOfDay,
  intervalToDuration,
  parseISO,
  startOfDay,
} from 'date-fns';
import { format, utcToZonedTime } from 'date-fns-tz';
import { PlatformService } from 'src/app/platform.service';

import { DataService ,GUEST_VEHICLE_ID} from 'src/app/services/data.service';
import { LoaderService } from 'src/app/services/loader.service';
import { PermitsService } from 'src/app/services/permits.service';
import { ToastService } from 'src/app/services/toast.service';
import {PaymentsPage} from '../../modals/payments/payments.page'
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { EnterlotpasswordPage } from 'src/app/pages/enterlotpassword/enterlotpassword.page';
@Component({
  selector: 'app-temporary-permit',
  templateUrl: './temporary-permit.page.html',
  styleUrls: ['./temporary-permit.page.scss'],
  providers: [DatePipe],
})
export class TemporaryPermitPage {
  guestVehicleID= GUEST_VEHICLE_ID
  @ViewChildren("divs") private divs: QueryList<ElementRef>;
  width=window.innerWidth;
  height=window.innerHeight;
  disableHourly = true;
  disableDaily = true;
  days;
  @ViewChild('datetime') datetime: IonDatetime;
  @ViewChild('datetime2') datetime2: IonDatetime;
  @ViewChild('datetime3') datetime3: IonDatetime;
  userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  date = new Date();
  minDate: any = format(utcToZonedTime(this.date, this.userTimeZone), "yyyy-MM-dd'T'HH:mm:ss'Z'", { timeZone: this.userTimeZone })
  maxDate: any = format(utcToZonedTime(this.date, this.userTimeZone), "yyyy-MM-dd'T'HH:mm:ss'Z'", { timeZone: this.userTimeZone });
  showHourlyPicker = false;
  showStartPicker = false;
  showEndPicker = false;
  formattedStartDate: any = 'Select Start Date';
  formattedHourlyDate: any = 'Select Date';
  formattedEndDate: any = 'Select End Date';
  loaded = false;
  permitType = 'daily';
  @Input() lot: any;
  @Input() isModal:any;
  permitDetails:any = {};
  tempPermitFormDaily: FormGroup;
  tempPermitFormHourly: FormGroup;
  tempPermitState = {
    invalid: true,
    checking: false,
    valid: false,
  };
  errors = {};
  postData = {};
  constructor(
    private renderer: Renderer2,
    private errorHandlerSRV:ErrorHandlerService,
    public platformSRV:PlatformService,
    private toasterSRV: ToastService,
    private modalCtrl: ModalController,
    private loaderSRV: LoaderService,
    public permitsSRV: PermitsService,
    private route: ActivatedRoute,
    public dataService: DataService,
    private router: Router,
    private fb: FormBuilder,
    private datePipe: DatePipe,
    public translateService: TranslateService,
  ) {}
  showMore(e:Event){
    
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[1], "display", 'none');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[2], "display", 'block');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[0], "overflow", 'visible');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[0], "height", 'auto');
    
  }
  showLess(e:Event){
    
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[1], "display", 'block');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[2], "display", 'none');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[0], "overflow", 'hidden');
    this.renderer.setStyle(<any>( <any>e.target ).parentNode.childNodes[0], "height", '60px');
    
  }
  closeModal() {
    if(this.isModal){
      this.modalCtrl.dismiss();
    } else {
      this.router.navigateByUrl('permits')
    }
    
  }
  hoursChanged(){
    this.tempPermitState.valid = false;
    this.tempPermitState.invalid = true;
  }
  plateChanged(){
    this.tempPermitState.valid = false;
    this.tempPermitState.invalid = true;
  }
  vehiclesChanged(){
    this.tempPermitState.valid = false;
    this.tempPermitState.invalid = true;
  }
  hourlyDateChanged(val) {
    this.tempPermitState.valid = false
    this.tempPermitState.invalid = true;
    this.formattedHourlyDate = format(parseISO(val.value), 'MMM d, yyyy hh:mm a');
  }
  endDateChanged(val) {
    this.tempPermitState.valid = false;
    this.tempPermitState.invalid = true;
    this.formattedEndDate = format(parseISO(val), 'MMM d, yyyy');
  }
  startDateChanged(val) {
    var newDate = new Date(val.value)
    newDate.setDate(newDate.getDate() + 30)
    this.tempPermitState.valid = false;
    this.tempPermitState.invalid = true;
    this.maxDate = format(utcToZonedTime(newDate, this.userTimeZone), "yyyy-MM-dd'T'HH:mm:ss'Z'", { timeZone: this.userTimeZone })
    
    this.formattedStartDate = format(parseISO(val.value), 'MMM d, yyyy');
  }

  closeStartDate() {
    this.datetime.cancel(false).then(() => {
      this.showStartPicker = false;
      this.tempPermitState.valid = false;
      this.tempPermitState.invalid = true;
      this.tempPermitFormDaily['dailyStartDate'] = '';
      this.formattedStartDate = 'Select Start Date';
      this.datetime.reset();
    });
  }
  SaveStartDate() {
    this.datetime.confirm(false).then(() => {
      this.showStartPicker = false;
    });
  }
  dailyPermitChanged(){
    this.tempPermitState.valid = false;
    this.tempPermitState.invalid = true;
    this.onTempPermitFormDailyValid(this.tempPermitFormDaily.value);
  }
  hourlyPermitChanged(){
    this.tempPermitState.valid = false;
    this.tempPermitState.invalid = true;
    this.onTempPermitFormHourlyValid(this.tempPermitFormHourly.value);
  }
  closehourlyDate() {
    this.datetime3.cancel(false).then(() => {
      this.tempPermitState.valid = false;
      this.tempPermitState.invalid = true;
      this.showHourlyPicker = false;
      this.tempPermitFormDaily['hourlyDate'] = '';
      this.formattedHourlyDate = 'Select Date';
      this.datetime3.reset();
    });
  }
  SavehourlyDate() {
    this.datetime3.confirm(false).then(() => {
      this.showHourlyPicker = false;
    });
  }
  segmentChanged(ev) {
    this.tempPermitState.valid = false;
    this.tempPermitState.invalid = true;
    this.tempPermitState.checking = false;
    this.permitDetails = {};
  }
  closeEndDate() {
    this.datetime2.cancel(false).then(() => {
      this.showEndPicker = false;
      this.tempPermitState.valid = false;
      this.tempPermitState.invalid = true;
      this.tempPermitFormDaily['dailyEndDate'] = '';
      this.formattedEndDate = 'Select End Date';
      this.datetime2.reset();
    });
  }
  SaveEndDate() {
    this.datetime2.confirm(false).then(() => {
      this.showEndPicker = false;
    });
  }
  showHourlyPickerfunction(){
    if(this.formattedHourlyDate=='Select Date'){
      this.formattedHourlyDate = format(parseISO(this.minDate), 'MMM d, yyyy hh:mm a');
   

  }
  this.showHourlyPicker=!this.showHourlyPicker
  }
  showStartPickerfunction(){
      if(this.formattedStartDate=='Select Start Date'){
        this.formattedStartDate = format(parseISO(this.minDate), 'MMM d, yyyy');
     

    }
    this.showStartPicker=!this.showStartPicker
  }
  showEndPickerfunction(){
    if(this.formattedEndDate=='Select End Date'){
      this.formattedEndDate = format(parseISO(this.tempPermitFormDaily.value['dailyStartDate']), 'MMM d, yyyy');
   

  }
  this.showEndPicker=!this.showEndPicker
  }
  async ionViewDidEnter() {
    this.loaded = false;
    if(!this.isModal){
      this.lot={}
      this.lot.LotNameID = this.route.snapshot.paramMap.get('id');
      
      
       
    }

    this.permitsSRV.permit.next({});
    const url = `permits/temporary/reservation/${this.lot.LotNameID}`;
    this.dataService.getData(url).subscribe({
      next: async (v:any) => {
        if (v?.error_code==2028) {
            const modal = await this.modalCtrl.create({
              component: EnterlotpasswordPage, // Component for entering the password
              componentProps: {
                LotNameID:this.lot.LotNameID,
                 permitType:"temp"
              } ,
            });
        
            await modal.present();
            const { data } = await modal.onDidDismiss();
            if (data && data.passwordEntered) {
              this.ionViewDidEnter()
            } else {
              this.closeModal()
            }
          
        } else {
          this.permitsSRV.permit.next(v);
          if (v['lot']['lot_hourly_cost'].length < 1) {
            this.disableHourly = true;
          } else {
            this.disableHourly = false;
          }
          if(v['lot']['TempPermitCost']==null){
            this.disableDaily = true;
            this.permitType='hourly'
          } else {
            this.disableDaily = false;
          }
          this.loaded = true;
          setTimeout(() => {
            this.divs.forEach(data=>{
              if(data.nativeElement.children[0].clientHeight<70){
                //hide show more button
                this.renderer.setStyle(data.nativeElement.children[1], "display", 'none');
                //hide show less button
                this.renderer.setStyle(data.nativeElement.children[2], "display", 'none');
              } else {
                //hide show less button
                this.renderer.setStyle(data.nativeElement.children[2], "display", 'none');
                this.renderer.setStyle(data.nativeElement.children[0], "height", '70px');
                this.renderer.setStyle(data.nativeElement.children[0], "overflow", 'hidden');
              }
              
            })
           }, 10);
        }
        
      },
      error: async (e) => {
        console.log(23213,e);
        
        
        this.errorHandlerSRV.displayErrorMessage(e,false).then(response=>{
          this.permitsSRV.permit.next(response.message);
        })
       
        this.loaded = true;
      }
    });
    this.tempPermitFormDaily = this.fb.group({
      permitType: 'daily',
      dailyStartDate: [this.minDate, [Validators.required]],
      dailyEndDate: [this.minDate, [Validators.required]],
      vehicle: ['', [Validators.required]],
      plate:['']
    });
   
   
   
    const roundedHourlyDate = this.getRoundedFutureTime(new Date());
    this.tempPermitFormHourly = this.fb.group({
      permitType: 'hourly',
      hourlyDate: [roundedHourlyDate, [Validators.required]],  // Initialize with the formatted date
      hourlyTime: [roundedHourlyDate, [Validators.required]],  // Initialize with the formatted time
      hours: ['', [Validators.required]],
      vehicle: ['', [Validators.required]],
      plate: ['']
    });
    
  }

    
  getRoundedFutureTime(date: Date): string {
    const minutes = date.getMinutes();
    // Calculate the rounded-up minutes using Math.ceil to ensure it moves forward
    const roundedMinutes = Math.ceil(minutes / 15) * 15;
    // If it goes beyond 60, adjust the hours and reset the minutes
    if (roundedMinutes === 60) {
      date.setHours(date.getHours() + 1);
      date.setMinutes(0);
    } else {
      date.setMinutes(roundedMinutes);
    }
  
    // Format the date to include timezone offset
    return format(utcToZonedTime(date, this.userTimeZone), "yyyy-MM-dd'T'HH:mm:ssXXX", { timeZone: this.userTimeZone });
  }

  private onTempPermitFormDailyValid(val: any) {
   
    if (this.tempPermitFormDaily.valid && this.formattedStartDate!='Select Start Date' && this.formattedEndDate!='Select End Date') {
      if(this.tempPermitFormDaily.value['vehicle']!=this.guestVehicleID){

      
      
      this.days =
        intervalToDuration({
          start: startOfDay(new Date(val.dailyStartDate)),
          end: endOfDay(new Date(val.dailyEndDate)),
        }).days + 1;
       
        
      this.tempPermitState.invalid = false;
      this.tempPermitState.checking = true;
      
      const data = {
        ...val,
        dailyStartDate: format(
          startOfDay(new Date(val.dailyStartDate)),
          'yyyy/MM/dd HH:mm:ss'
        ),
        dailyEndDate: format(
          endOfDay(new Date(val.dailyEndDate)),
          'yyyy/MM/dd HH:mm:ss'
        ),
      };
      this.postData = data;
      
      this.checkValidation(data);
    }
    else {
     
      
      if(this.tempPermitFormDaily.value['plate'].trim()!=''){
        this.days =
        intervalToDuration({
          start: startOfDay(new Date(val.dailyStartDate)),
          end: endOfDay(new Date(val.dailyEndDate)),
        }).days + 1;
       
        
      this.tempPermitState.invalid = false;
      this.tempPermitState.checking = true;
      const data = {
        ...val,
        dailyStartDate: format(
          startOfDay(new Date(val.dailyStartDate)),
          'yyyy/MM/dd HH:mm:ss'
        ),
        dailyEndDate: format(
          endOfDay(new Date(val.dailyEndDate)),
          'yyyy/MM/dd HH:mm:ss'
        ),
      };
      this.postData = data;
      
      this.checkValidation(data);
      }
    }
        
      
    } else {
     
      this.tempPermitState.valid = false;
      this.tempPermitState.invalid = true;
      this.tempPermitState.checking = false;
    }
  }

  private onTempPermitFormHourlyValid(val: any) {    
    if (this.tempPermitFormHourly.valid && this.formattedHourlyDate!='Select Date'  ) {
      if(this.tempPermitFormHourly.value['vehicle']!=this.guestVehicleID){

      this.tempPermitState.invalid = false;
      this.tempPermitState.checking = true;
     
      const data = {
        ...val,
        hourlyDate: this.datePipe.transform(val.hourlyDate, 'yyyy/MM/dd'),
        hourlyTime: this.datePipe.transform(val.hourlyDate, 'hh:mm a'),
      };
      this.postData = data;
      
      this.checkValidation(data);
    }
else {
  if(this.tempPermitFormHourly.value['plate'].trim()!=''){
    this.tempPermitState.invalid = false;
    this.tempPermitState.checking = true;

    const data = {
      ...val,
      hourlyDate: this.datePipe.transform(val.hourlyDate, 'yyyy/MM/dd'),
      hourlyTime: this.datePipe.transform(val.hourlyDate, 'hh:mm a'),
    };
    this.postData = data;
    
    this.checkValidation(data);
  }
}  
  } else{
      this.tempPermitState.valid = false;
      this.tempPermitState.invalid = true;
      this.tempPermitState.checking = false;
    }
    
  }

  private checkValidation(data: any) {
    const url = `api/v2/user/permits/lot/${this.lot.LotNameID}/temporary/check`;
    this.dataService.postData(url, data).subscribe( {
    next:(res:any)=>{
      var taxes=[]
        for (var i = 0; i < Object.entries(res?.permit?.taxes).length; i++)
      {
        taxes.push( Object.entries(res?.permit?.taxes)[i][1])
        
      }
      res.permit.taxes = taxes
      this.permitDetails = res['permit'] ? res['permit'] : {};
      this.tempPermitState.checking = false;
      if (res['status'] === 'error') {
        if(res['message']){
          this.toasterSRV.presentErrorToast(res['message'])
        }
        this.tempPermitState.invalid = true;
        if(res && res['errors']){
          this.errors = res['errors'];
        }
        
      } else { 
        if(res['error']){
          this.toasterSRV.presentErrorToast(
            res['message']
           );
          this.tempPermitState.valid = false;
        } else {
          this.errors = {};
          this.tempPermitState.valid = true;
        }
        
      }
    }
      ,error:err=>{
        this.tempPermitState.checking = false;
        this.tempPermitState.invalid = true;
        this.errorHandlerSRV.displayErrorMessage(err,false).then(response=>{
          this.errors=response.fields
        })
      }
    });
  }

  onReservePermit() {
    this.loaderSRV.showLoader(this.translateService.instant('keys.data.permits.reserving_permit') || 'Reserving permit...')
    const url = `api/v2/user/permits/lot/${this.lot.LotNameID}/temporary/reserve`;
    this.dataService.postData(url, this.postData).subscribe({
      next: async (v) => {
        if(v['status']=="success"){

        
        this.loaderSRV.dismissLoader();
        this.modalCtrl.dismiss();
        this.toasterSRV.presentToast(this.translateService.instant('keys.data.permits.permit_reserved') || 'Permit reserved successfully');
        const desktopModal = await this.modalCtrl.create({
          component: PaymentsPage,
          breakpoints: [0.5, 0.8,1],
         
          cssClass: 'modal-desktop-long',
         
        });
        const mobileModal = await this.modalCtrl.create({
          component: PaymentsPage,
          breakpoints: [0.5, 0.8,1],
          initialBreakpoint: 1,
          cssClass:"modal-mobile-normal",
         
        })
        const tabletModal = await this.modalCtrl.create({
          component: PaymentsPage,
          breakpoints: [0.5, 0.8,1],
          initialBreakpoint: 1, 
          cssClass:"modal-tablet-normal",
         
        })
        var modal = await this.dataService.getModalType(mobileModal, tabletModal, desktopModal)
        modal.present()
      } else {
        this.loaderSRV.dismissLoader();
        this.errorHandlerSRV.displayErrorMessage(v,true)
      }
      },
      error: (err) => {
        this.errorHandlerSRV.displayErrorMessage(err,true)
      },
    });
  }
}
